/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TradeLookupRouteImport } from './routes/trade-lookup'
import { Route as TradeDetailsRouteImport } from './routes/trade-details'
import { Route as StaticDataLookupRouteImport } from './routes/static-data-lookup'
import { Route as StaticDataDetailsRouteImport } from './routes/static-data-details'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ProposedMatchingRouteImport } from './routes/proposed-matching'
import { Route as PairOffReviewRouteImport } from './routes/pair-off-review'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExceptionsRouteImport } from './routes/exceptions'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaticEntryAddTypeRouteImport } from './routes/static-entry.add.$type'
import { Route as StaticEntryEditTypeIdRouteImport } from './routes/static-entry.edit.$type.$id'

const TradeLookupRoute = TradeLookupRouteImport.update({
  id: '/trade-lookup',
  path: '/trade-lookup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/trade-lookup.lazy').then((d) => d.Route))
const TradeDetailsRoute = TradeDetailsRouteImport.update({
  id: '/trade-details',
  path: '/trade-details',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/trade-details.lazy').then((d) => d.Route))
const StaticDataLookupRoute = StaticDataLookupRouteImport.update({
  id: '/static-data-lookup',
  path: '/static-data-lookup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/static-data-lookup.lazy').then((d) => d.Route),
)
const StaticDataDetailsRoute = StaticDataDetailsRouteImport.update({
  id: '/static-data-details',
  path: '/static-data-details',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/static-data-details.lazy').then((d) => d.Route),
)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/reports.lazy').then((d) => d.Route))
const ProposedMatchingRoute = ProposedMatchingRouteImport.update({
  id: '/proposed-matching',
  path: '/proposed-matching',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/proposed-matching.lazy').then((d) => d.Route),
)
const PairOffReviewRoute = PairOffReviewRouteImport.update({
  id: '/pair-off-review',
  path: '/pair-off-review',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/pair-off-review.lazy').then((d) => d.Route),
)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const ExceptionsRoute = ExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/exceptions.lazy').then((d) => d.Route))
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const StaticEntryAddTypeRoute = StaticEntryAddTypeRouteImport.update({
  id: '/static-entry/add/$type',
  path: '/static-entry/add/$type',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/static-entry.add.$type.lazy').then((d) => d.Route),
)
const StaticEntryEditTypeIdRoute = StaticEntryEditTypeIdRouteImport.update({
  id: '/static-entry/edit/$type/$id',
  path: '/static-entry/edit/$type/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/static-entry.edit.$type.$id.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/exceptions': typeof ExceptionsRoute
  '/login': typeof LoginRoute
  '/pair-off-review': typeof PairOffReviewRoute
  '/proposed-matching': typeof ProposedMatchingRoute
  '/reports': typeof ReportsRoute
  '/static-data-details': typeof StaticDataDetailsRoute
  '/static-data-lookup': typeof StaticDataLookupRoute
  '/trade-details': typeof TradeDetailsRoute
  '/trade-lookup': typeof TradeLookupRoute
  '/static-entry/add/$type': typeof StaticEntryAddTypeRoute
  '/static-entry/edit/$type/$id': typeof StaticEntryEditTypeIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/exceptions': typeof ExceptionsRoute
  '/login': typeof LoginRoute
  '/pair-off-review': typeof PairOffReviewRoute
  '/proposed-matching': typeof ProposedMatchingRoute
  '/reports': typeof ReportsRoute
  '/static-data-details': typeof StaticDataDetailsRoute
  '/static-data-lookup': typeof StaticDataLookupRoute
  '/trade-details': typeof TradeDetailsRoute
  '/trade-lookup': typeof TradeLookupRoute
  '/static-entry/add/$type': typeof StaticEntryAddTypeRoute
  '/static-entry/edit/$type/$id': typeof StaticEntryEditTypeIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/exceptions': typeof ExceptionsRoute
  '/login': typeof LoginRoute
  '/pair-off-review': typeof PairOffReviewRoute
  '/proposed-matching': typeof ProposedMatchingRoute
  '/reports': typeof ReportsRoute
  '/static-data-details': typeof StaticDataDetailsRoute
  '/static-data-lookup': typeof StaticDataLookupRoute
  '/trade-details': typeof TradeDetailsRoute
  '/trade-lookup': typeof TradeLookupRoute
  '/static-entry/add/$type': typeof StaticEntryAddTypeRoute
  '/static-entry/edit/$type/$id': typeof StaticEntryEditTypeIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/exceptions'
    | '/login'
    | '/pair-off-review'
    | '/proposed-matching'
    | '/reports'
    | '/static-data-details'
    | '/static-data-lookup'
    | '/trade-details'
    | '/trade-lookup'
    | '/static-entry/add/$type'
    | '/static-entry/edit/$type/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/exceptions'
    | '/login'
    | '/pair-off-review'
    | '/proposed-matching'
    | '/reports'
    | '/static-data-details'
    | '/static-data-lookup'
    | '/trade-details'
    | '/trade-lookup'
    | '/static-entry/add/$type'
    | '/static-entry/edit/$type/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/exceptions'
    | '/login'
    | '/pair-off-review'
    | '/proposed-matching'
    | '/reports'
    | '/static-data-details'
    | '/static-data-lookup'
    | '/trade-details'
    | '/trade-lookup'
    | '/static-entry/add/$type'
    | '/static-entry/edit/$type/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ExceptionsRoute: typeof ExceptionsRoute
  LoginRoute: typeof LoginRoute
  PairOffReviewRoute: typeof PairOffReviewRoute
  ProposedMatchingRoute: typeof ProposedMatchingRoute
  ReportsRoute: typeof ReportsRoute
  StaticDataDetailsRoute: typeof StaticDataDetailsRoute
  StaticDataLookupRoute: typeof StaticDataLookupRoute
  TradeDetailsRoute: typeof TradeDetailsRoute
  TradeLookupRoute: typeof TradeLookupRoute
  StaticEntryAddTypeRoute: typeof StaticEntryAddTypeRoute
  StaticEntryEditTypeIdRoute: typeof StaticEntryEditTypeIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trade-lookup': {
      id: '/trade-lookup'
      path: '/trade-lookup'
      fullPath: '/trade-lookup'
      preLoaderRoute: typeof TradeLookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade-details': {
      id: '/trade-details'
      path: '/trade-details'
      fullPath: '/trade-details'
      preLoaderRoute: typeof TradeDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static-data-lookup': {
      id: '/static-data-lookup'
      path: '/static-data-lookup'
      fullPath: '/static-data-lookup'
      preLoaderRoute: typeof StaticDataLookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static-data-details': {
      id: '/static-data-details'
      path: '/static-data-details'
      fullPath: '/static-data-details'
      preLoaderRoute: typeof StaticDataDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposed-matching': {
      id: '/proposed-matching'
      path: '/proposed-matching'
      fullPath: '/proposed-matching'
      preLoaderRoute: typeof ProposedMatchingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair-off-review': {
      id: '/pair-off-review'
      path: '/pair-off-review'
      fullPath: '/pair-off-review'
      preLoaderRoute: typeof PairOffReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exceptions': {
      id: '/exceptions'
      path: '/exceptions'
      fullPath: '/exceptions'
      preLoaderRoute: typeof ExceptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static-entry/add/$type': {
      id: '/static-entry/add/$type'
      path: '/static-entry/add/$type'
      fullPath: '/static-entry/add/$type'
      preLoaderRoute: typeof StaticEntryAddTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/static-entry/edit/$type/$id': {
      id: '/static-entry/edit/$type/$id'
      path: '/static-entry/edit/$type/$id'
      fullPath: '/static-entry/edit/$type/$id'
      preLoaderRoute: typeof StaticEntryEditTypeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ExceptionsRoute: ExceptionsRoute,
  LoginRoute: LoginRoute,
  PairOffReviewRoute: PairOffReviewRoute,
  ProposedMatchingRoute: ProposedMatchingRoute,
  ReportsRoute: ReportsRoute,
  StaticDataDetailsRoute: StaticDataDetailsRoute,
  StaticDataLookupRoute: StaticDataLookupRoute,
  TradeDetailsRoute: TradeDetailsRoute,
  TradeLookupRoute: TradeLookupRoute,
  StaticEntryAddTypeRoute: StaticEntryAddTypeRoute,
  StaticEntryEditTypeIdRoute: StaticEntryEditTypeIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
